module.exports = __webpack_public_path__ + "img/photo_2023-11-19 17.44.02.82c45a0d.jpg";